import { Auth } from '@efishery/sdk-core';
import { AUTH_V2_CLIENT_ID, AUTH_V2_STAGE, IS_TESTING_ENV } from '@/config';

// enableCookieKeys only enable when the app
// not running in the test environment
export const auth = new Auth(AUTH_V2_CLIENT_ID, AUTH_V2_STAGE, { enableCookieKeys: !IS_TESTING_ENV });
